export class BACGreetingCardData {
    greetingCard = null
    applyToAll = null

    constructor(greetingCard, applyToAll) {
        this.greetingCard = greetingCard
        this.applyToAll = applyToAll
    }
}
